export default {
  startingPitchers: {
    title: "Lanceurs partants",
    tabs: {
      byPitcher: "Par lanceur",
      allPitchers: "Tous les lanceurs",
    },
    labels: {
      confirmed: "CONFIRMÉ",
      expected: "PRÉVU",
      pitcher: "LANCEUR",
      tbd: "À DÉTERMINER",
    },
    empty: {
      title: "Aucun lanceur partant disponible",
    },
  },
};
